"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualDetailsUtil = void 0;
class IndividualDetailsUtil {
    constructor() {
    }
    static getEmptyPersonalInformation() {
        return {
            individualId: null,
            firstName: '',
            middleName: '',
            lastName: '',
            birthDate: '',
            gender: '',
            ethnicity: '',
            race: ''
        };
    }
    static getEmptyPhysicalCharacteristics() {
        return {
            height: '',
            weight: '',
            eyeColor: '',
            hairColor: ''
        };
    }
    static getEmptyContactInformation() {
        return {
            address: '',
            address2: '',
            phoneNumber: '',
            city: '',
            state: '',
            zip: ''
        };
    }
    static getEmptyIdentification() {
        return {
            ssn: '',
            sidNumber: '',
            dlNumber: '',
            fbiNumber: ''
        };
    }
    static getFormatSnn(ssn) {
        if (!ssn || ssn.length !== 9)
            return ssn; // return original if not valid
        return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5)}`;
    }
}
exports.IndividualDetailsUtil = IndividualDetailsUtil;
